<template>
	<div :key="secondPageRefreshKey" v-if="!$props.isEdit">
		<div v-if="newProspects.type == 1">
			<div class="flex justify-between items-start">
				<!-- Your HTML content goes here -->
				<div class="flex items-center space-x-4 space-y-5">
					<div>
						<label for="mainUrl">Url</label>
						<vs-input v-model="mainUrl" @keyup.enter="onclickSaveUrl()" />
					</div>
					<vs-button ref="prospect-run-button-1" @click="onclickSaveUrl()"
						>Lancer</vs-button
					>
				</div>
				<div class="flex items-start">
					<vs-button @click="exportKeywords()">Exporter</vs-button>
				</div>
			</div>
			<div>
				<prospect-second-page-url-table
					v-if="showSecondPageUrlTable"
					:mainUrl="mainUrl"
					:isLoadingDfs="isLoadingDfs"
					:keywordList="keywordList"
					:key="keywordsTableKey"
					:isEdit="$props.isEdit"
					@updated-top-keywords="updateAndHideModifyTopKeywords($event)"
					ref="prospectSecondPageUrlTableRef"
				/>
			</div>
		</div>
		<div v-if="[2, 3].includes(newProspects.type)">
			<div class="flex justify-between space-x-20">
				<TopKeywordEditor
					:analyseType="newProspects.type"
					ref="topKeywordsEditor"
					:topKeywordFromSuggestion="topKeywordFromSuggestion"
					:topKeywords="topKeywords"
					@toogle-save="onToogleSave($event)"
					:key="topKeywordsEditorKey"
					@updated-top-keywords="updateAndHideModifyTopKeywords($event)"
					@close-popup="cancelAndHideModifyTopKeywords"
				/>

				<!-- <KeywordsIdeasCard
					@click-choose-keyword="updateKeywordsFromSuggestion($event)"
					:prospectsSearch="newProspects"
					:keywords="topKeywords.concat(topKeywordFromSuggestion)"
				/> -->
			</div>
		</div>
	</div>
	<div v-else><UpdateKeywordsPage :projectId="newProspects.project_id" /></div>
</template>

<script>
import * as XLSX from "xlsx";
import store from "@/store/store";
import DFS from "../../../entities/DFS";
import ProspectSecondPageUrlTable from "../../../components/tables/ProspectSecondPageUrlTable.vue";
import utilsMixin from "../../../mixins/utilsMixin";
import TopKeywordEditor from "../../../components/views/dashboard/keywords/TopKeywordEditor.vue";
import KeywordsIdeasCard from "../../../components/views/dashboard/prospection/KeywordsIdeasCard.vue";
import ProspectSearch from "../../../entities/ProspectSearch";
import UpdateKeywordsPage from "./UpdateKeywordsPage.vue";
import ProspectionSuggestionAIBox from "./ProspectionSuggestionAIBox.vue";

export default {
	components: {
		ProspectSecondPageUrlTable,
		TopKeywordEditor,
		KeywordsIdeasCard,
		UpdateKeywordsPage,
		ProspectionSuggestionAIBox,
	},
	name: "ProspectSecondPageUrl",
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [utilsMixin],
	// Your component's logic goes here
	data() {
		return {
			mainUrl: null,
			keywordList: [],
			choosenKeywords: [],
			// second part
			topKeywordFromSuggestion: [],
			topKeywords: [],
			keywordsTableKey: 0,
			secondPageRefreshKey: 0,
			isLoading: false,
			topKeywordsEditorKey: 0,
			isLoadingDfs: false,

			// AI Suggestion
			runAiSuggestions: false,
			showSecondPageUrlTable: false,
		};
	},
	watch: {
		// mainUrl: function (data) {},
		keywordList: function (data) {
			this.keywordsTableKey++;
		},
	},
	computed: {
		// Your component's computed properties go here
		newProspects() {
			return store.state.newProspects;
		},
		oldProspects() {
			return store.state.oldProspects;
		},
		keywordListByAi() {
			return store.state.keywordListByAi;
		},
	},
	created() {
		console.log("Running ProspectSecondPage created");
		if (this.$props.isEdit) {
			this.keywordList = this.newProspects.keyword_list;
			this.topKeywords = this.newProspects.keyword_list;
			this.secondPageRefreshKey++;
		}
	},
	updated() {
		// console.log("Running ProspectSecondPage updated", {
		// 	isEdit: this.$props.isEdit,
		// 	chooseKeywords: this.oldProspects.keyword_list,
		// });
	},
	methods: {
		validateAllFields() {
			console.log("Running ProspectSecondPage validateAllField");
			let pass = true;
			if (this.newProspects.type == 1) {
				// Name
				pass = this.$refs.prospectSecondPageUrlTableRef.validateAllFields();
				if (!pass) {
					this.$vs.notify({
						color: "danger",
						title: "Echec",
						text: "Veuillez ajouter des mots clés",
					});
					pass = false;
				}
			} else {
				pass = this.$refs.topKeywordsEditor.validateAllFields();
			}
			return pass;
		},
		async onclickSaveUrl() {
			if (this.mainUrl == null || this.mainUrl == "") return;
			else {
				try {
					this.isLoadingDfs = true;
					this.showSecondPageUrlTable = true;
					// this.setLoading(true, "prospect-run-button-1");
					// if (this.$props.isEdit) await this.deleteProspectsInfo();
					this.$store.dispatch("setNewProspects", {
						...this.newProspects,
						mainUrl: this.mainUrl,
					});
					this.runAiSuggestions = true;
					await this.fetchKeywordsForDomain();
				} catch (e) {
					console.log("Error in onclickSaveUrl", e);
				} finally {
					this.isLoadingDfs = false;
					// this.setLoading(false, "prospect-run-button-1");
				}
			}
		},
		/**Delete informtation related to prospects  */
		async deleteProspectsInfo() {
			try {
				await ProspectSearch.deleteProspectByProjectId(
					this.newProspects.project_id
				);
				await ProspectSearch.deleteKeywordsByProjectId(
					this.newProspects.project_id
				);
				this.$store.dispatch("setNewProspects", {
					...this.newProspects,
					keywordList: [],
					keyword_list: [],
				});
				this.choosenKeywords = [];
			} catch (e) {
				console.log("Error in deleteProspectsInfo", e);
				throw e;
			}
		},
		/**
		 * Fetch keywords for domain
		 */
		async fetchKeywordsForDomain() {
			return new Promise((resolve, reject) => {
				const body = {
					domain: this.mainUrl,
					language_code: this.newProspects.language_id,
					location_code: this.newProspects.location_id,
					language_name: this.newProspects.language_name,
				};
				DFS.getKeywordsForDomain(body)
					.then((response) => {
						this.keywordList = response;
						this.keywordsTableKey++;

						this.setLoading(false, "prospect-run-button-1");
						resolve(response);
					})
					.catch((error) => {
						this.setLoading(false, "prospect-run-button-1");
						console.log("Error in message1", error);
						this.$vs.notify({
							title: "Echec",
							color: "danger",
							text: error,
						});
						this.$vs.notify({
							title: "Attention",
							color: "warning",
							text: "Veuillez vérifier si votre domain est correct",
						});
						reject(error);
					});
			});
			// this.$http
			// 	.get(
			// 		`dataforseo/getKeywordsForDomain?domain=${this.mainUrl}&language_code=${this.newProspects.language_id}&location_code=${this.newProspects.location_id}`
			// 	)
			// 	.then((response) => {
			// 		try {
			// 			this.keywordList = response.data;
			// 			this.keywordsTableKey++;
			// 		} catch (e) {
			// 			console.log("Error in message1", e);
			// 		}

			// 		// Your code here
			// 	})
			// 	.catch((error) => {
			// 		this.isloading = fasle;
			// 		// Your code here
			// 	});
		},
		updateKeywordsFromSuggestion(tks) {
			this.topKeywordFromSuggestion = tks;
			this.saveButtonKey++;
			this.topKeywordsEditorKey++;
			// this.keywordsIdeaKey++;
			this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		checkDisableSaveButton() {
			if (this.topKeywords.length > 0) this.isDisableSaveButton = false;
			else this.isDisableSaveButton = true;
		},
		onToogleSave(toogleSave) {
			this.isDisableSaveButton = !toogleSave;
			this.saveButtonKey++;
		},
		updateAndHideModifyTopKeywords(tks) {
			this.showModifyTopKeywords = false;
			this.topKeywords = tks;
			this.$store.dispatch("setNewProspects", {
				...this.newProspects,
				keywordList: tks.map((tk) => tk.keyword),
			});
			this.saveButtonKey++;
			// this.keywordsIdeaKey++;

			// this.checkDisableSaveButton();
			// this.showModifyTopKeywords = false;
		},
		cancelAndHideModifyTopKeywords() {
			this.showModifyTopKeywords = false;
		},
		/** Export Keywords */
		exportKeywords() {
			// Extract only `cpc` and `search_volume` fields
			const exportData = this.keywordList.map((item) => ({
				keyword: item.keyword, // Adding keyword for context
				cpc: item.cpc,
				search_volume: item.search_volume, // Join array as comma-separated string
			}));

			const exportDataAi = this.keywordListByAi.map((item) => ({
				keyword: item.keyword, // Adding keyword for context
				cpc: item.cpc,
				search_volume: item.search_volume, // Join array as comma-separated string
			}));

			// Create a worksheet from the data
			const worksheet = XLSX.utils.json_to_sheet(
				exportData.concat(exportDataAi)
			);

			// Create a new workbook
			const workbook = XLSX.utils.book_new();

			// Append the worksheet to the workbook
			XLSX.utils.book_append_sheet(workbook, worksheet, "Prospect List");

			// Export the workbook to Excel file
			XLSX.writeFile(workbook, "prospect_list.xlsx");
		},
		// Your component's methods go here
		greet() {
			console.log(this.message);
		},
	},
};
</script>

<style scoped>
/* Your component's styles go here */
h1 {
	color: blue;
}
</style>